var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 467;
var h = 467;
var nm = "transfer  nofade";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Shape Layer 1",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    232,
                    234,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -665,
                                        185
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.149019607843,
                                0.737254901961,
                                0.38431372549,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 8,
                            ix: 5
                        },
                        lc: 1,
                        lj: 1,
                        ml: 4,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.525489956725,
                                0.337254991718,
                                0.937255021638,
                                1
                            ],
                            ix: 4
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Shape 1",
                np: 3,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "r arrow head 3",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 180,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    359.626,
                    41.542,
                    0
                ],
                ix: 2,
                l: 2,
                x: "var $bm_rt;\n$bm_rt = thisComp.layer('r arrow body 2: Path 1 [1.1.0]').transform.position;"
            },
            a: {
                a: 0,
                k: [
                    -2.304,
                    -0.125,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -44.167,
                                        47.708
                                    ],
                                    [
                                        6.667,
                                        0
                                    ],
                                    [
                                        -43.542,
                                        -49.583
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 1,
                            k: [
                                {
                                    i: {
                                        x: [
                                            0.667,
                                            0.667
                                        ],
                                        y: [
                                            1,
                                            1
                                        ]
                                    },
                                    o: {
                                        x: [
                                            0.333,
                                            0.333
                                        ],
                                        y: [
                                            0,
                                            0
                                        ]
                                    },
                                    t: 15,
                                    s: [
                                        0,
                                        0
                                    ]
                                },
                                {
                                    t: 21.0000008553475,
                                    s: [
                                        100,
                                        100
                                    ],
                                    h: 1
                                }
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.149019613862,
                        0.737254917622,
                        0.384313762188,
                        1
                    ],
                    ix: 3,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 14,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            }
        ],
        ip: 14.0000005702317,
        op: 111.000004521123,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 3,
        nm: "r arrow body 2: Path 1 [1.1.0]",
        cl: "1 0",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 0,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 1,
                k: [
                    {
                        i: {
                            x: 0.667,
                            y: 1
                        },
                        o: {
                            x: 0.333,
                            y: 0
                        },
                        t: 14,
                        s: [
                            440.667,
                            160.667,
                            0
                        ],
                        to: [
                            -46.667,
                            0,
                            0
                        ],
                        ti: [
                            0,
                            0,
                            0
                        ]
                    },
                    {
                        t: 21.0000008553475,
                        s: [
                            160.667,
                            160.667,
                            0
                        ]
                    }
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        ip: 14.0000005702317,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 5,
        ty: 3,
        nm: "r arrow body 2: Path 1 [1.1.1]",
        cl: "1 1",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 0,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 1,
                k: [
                    {
                        i: {
                            x: 0.667,
                            y: 1
                        },
                        o: {
                            x: 0.333,
                            y: 0
                        },
                        t: 14,
                        s: [
                            441.667,
                            160.667,
                            0
                        ],
                        to: [
                            -21.667,
                            0,
                            0
                        ],
                        ti: [
                            0,
                            0,
                            0
                        ]
                    },
                    {
                        t: 21.0000008553475,
                        s: [
                            311.667,
                            160.667,
                            0
                        ]
                    }
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        ip: 14.0000005702317,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "r arrow body 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    266.667,
                    160.667,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        ef: [
            {
                ty: 5,
                nm: "r arrow body: Path 1 [1.1.0]",
                np: 3,
                mn: "ADBE Layer Control",
                ix: 1,
                en: 1,
                ef: [
                    {
                        ty: 10,
                        nm: "Layer",
                        mn: "ADBE Layer Control-0001",
                        ix: 1,
                        v: {
                            a: 0,
                            k: 7,
                            ix: 1
                        }
                    }
                ]
            },
            {
                ty: 5,
                nm: "r arrow body: Path 1 [1.1.1]",
                np: 3,
                mn: "ADBE Layer Control",
                ix: 2,
                en: 1,
                ef: [
                    {
                        ty: 10,
                        nm: "Layer",
                        mn: "ADBE Layer Control-0001",
                        ix: 1,
                        v: {
                            a: 0,
                            k: 8,
                            ix: 1
                        }
                    }
                ]
            },
            {
                ty: 5,
                nm: "r arrow body 2: Path 1 [1.1.0]",
                np: 3,
                mn: "ADBE Layer Control",
                ix: 3,
                en: 1,
                ef: [
                    {
                        ty: 10,
                        nm: "Layer",
                        mn: "ADBE Layer Control-0001",
                        ix: 1,
                        v: {
                            a: 0,
                            k: 4,
                            ix: 1
                        }
                    }
                ]
            },
            {
                ty: 5,
                nm: "r arrow body 2: Path 1 [1.1.1]",
                np: 3,
                mn: "ADBE Layer Control",
                ix: 4,
                en: 1,
                ef: [
                    {
                        ty: 10,
                        nm: "Layer",
                        mn: "ADBE Layer Control-0001",
                        ix: 1,
                        v: {
                            a: 0,
                            k: 5,
                            ix: 1
                        }
                    }
                ]
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -20,
                                        0
                                    ],
                                    [
                                        20,
                                        0
                                    ]
                                ],
                                c: false
                            },
                            ix: 2,
                            x: "var $bm_rt;\nvar nullLayerNames = [\n    'r arrow body 2: Path 1 [1.1.0]',\n    'r arrow body 2: Path 1 [1.1.1]'\n];\nvar origPath = thisProperty;\nvar origPoints = origPath.points();\nvar origInTang = origPath.inTangents();\nvar origOutTang = origPath.outTangents();\nvar getNullLayers = [];\nfor (var i = 0, il = nullLayerNames.length; i < il; i++) {\n    try {\n        getNullLayers.push(effect(nullLayerNames[i])('ADBE Layer Control-0001'));\n    } catch (err) {\n        getNullLayers.push(null);\n    }\n}\nfor (var i = 0, il = getNullLayers.length; i < il; i++) {\n    if (getNullLayers[i] != null && getNullLayers[i].index != thisLayer.index) {\n        origPoints[i] = fromCompToSurface(getNullLayers[i].toComp(getNullLayers[i].anchorPoint));\n    }\n}\n$bm_rt = createPath(origPoints, origInTang, origOutTang, origPath.isClosed());"
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.149019613862,
                                0.737254917622,
                                0.384313732386,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 14,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 14.0000005702317,
        op: 111.000004521123,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 7,
        ty: 3,
        nm: "r arrow body: Path 1 [1.1.0]",
        cl: "1 0",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 0,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 1,
                k: [
                    {
                        i: {
                            x: 0.667,
                            y: 1
                        },
                        o: {
                            x: 0.333,
                            y: 0
                        },
                        t: 14,
                        s: [
                            13.292,
                            290.667,
                            0
                        ],
                        to: [
                            24.833,
                            0,
                            0
                        ],
                        ti: [
                            0,
                            0,
                            0
                        ]
                    },
                    {
                        t: 21.0000008553475,
                        s: [
                            162.292,
                            290.667,
                            0
                        ]
                    }
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        ip: 14.0000005702317,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 8,
        ty: 3,
        nm: "r arrow body: Path 1 [1.1.1]",
        cl: "1 1",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 0,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 1,
                k: [
                    {
                        i: {
                            x: 0.667,
                            y: 1
                        },
                        o: {
                            x: 0.333,
                            y: 0
                        },
                        t: 14,
                        s: [
                            12.042,
                            290.667,
                            0
                        ],
                        to: [
                            0,
                            0,
                            0
                        ],
                        ti: [
                            0,
                            0,
                            0
                        ]
                    },
                    {
                        t: 21.0000008553475,
                        s: [
                            311.042,
                            290.667,
                            0
                        ]
                    }
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        ip: 14.0000005702317,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 9,
        ty: 4,
        nm: "r arrow head 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    359.626,
                    171.542,
                    0
                ],
                ix: 2,
                l: 2,
                x: "var $bm_rt;\n$bm_rt = thisComp.layer('r arrow body: Path 1 [1.1.1]').transform.position;"
            },
            a: {
                a: 0,
                k: [
                    -2.304,
                    -0.125,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -43.542,
                                        -49.583
                                    ],
                                    [
                                        6.667,
                                        0
                                    ],
                                    [
                                        -44.167,
                                        47.708
                                    ]
                                ],
                                c: false
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('r arrow head 3').content('Group 1').transform.scale;"
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "st",
                c: {
                    a: 0,
                    k: [
                        0.149019613862,
                        0.737254917622,
                        0.384313762188,
                        1
                    ],
                    ix: 3,
                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 4
                },
                w: {
                    a: 0,
                    k: 14,
                    ix: 5
                },
                lc: 2,
                lj: 2,
                bm: 0,
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
            }
        ],
        ip: 14.0000005702317,
        op: 111.000004521123,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 10,
        ty: 4,
        nm: "r arrow body",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    266.667,
                    290.667,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        ef: [
            {
                ty: 5,
                nm: "r arrow body: Path 1 [1.1.0]",
                np: 3,
                mn: "ADBE Layer Control",
                ix: 1,
                en: 1,
                ef: [
                    {
                        ty: 10,
                        nm: "Layer",
                        mn: "ADBE Layer Control-0001",
                        ix: 1,
                        v: {
                            a: 0,
                            k: 7,
                            ix: 1
                        }
                    }
                ]
            },
            {
                ty: 5,
                nm: "r arrow body: Path 1 [1.1.1]",
                np: 3,
                mn: "ADBE Layer Control",
                ix: 2,
                en: 1,
                ef: [
                    {
                        ty: 10,
                        nm: "Layer",
                        mn: "ADBE Layer Control-0001",
                        ix: 1,
                        v: {
                            a: 0,
                            k: 8,
                            ix: 1
                        }
                    }
                ]
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        -20,
                                        0
                                    ],
                                    [
                                        20,
                                        0
                                    ]
                                ],
                                c: false
                            },
                            ix: 2,
                            x: "var $bm_rt;\nvar nullLayerNames = [\n    'r arrow body: Path 1 [1.1.0]',\n    'r arrow body: Path 1 [1.1.1]'\n];\nvar origPath = thisProperty;\nvar origPoints = origPath.points();\nvar origInTang = origPath.inTangents();\nvar origOutTang = origPath.outTangents();\nvar getNullLayers = [];\nfor (var i = 0, il = nullLayerNames.length; i < il; i++) {\n    try {\n        getNullLayers.push(effect(nullLayerNames[i])('ADBE Layer Control-0001'));\n    } catch (err) {\n        getNullLayers.push(null);\n    }\n}\nfor (var i = 0, il = getNullLayers.length; i < il; i++) {\n    if (getNullLayers[i] != null && getNullLayers[i].index != thisLayer.index) {\n        origPoints[i] = fromCompToSurface(getNullLayers[i].toComp(getNullLayers[i].anchorPoint));\n    }\n}\n$bm_rt = createPath(origPoints, origInTang, origOutTang, origPath.isClosed());"
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.149019613862,
                                0.737254917622,
                                0.384313732386,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 14,
                            ix: 5
                        },
                        lc: 2,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 14.0000005702317,
        op: 111.000004521123,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 11,
        ty: 4,
        nm: "circle",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.34
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.66
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            0
                        ]
                    },
                    {
                        i: {
                            x: [
                                0.835
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.647
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 14,
                        s: [
                            100
                        ]
                    },
                    {
                        i: {
                            x: [
                                0.668
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.335
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 116,
                        s: [
                            100
                        ]
                    },
                    {
                        t: 120.0000048877,
                        s: [
                            0
                        ]
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    232,
                    232,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    361.875,
                    361.875,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        35.346
                                    ],
                                    [
                                        35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        -35.346
                                    ]
                                ],
                                o: [
                                    [
                                        35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        -35.346
                                    ],
                                    [
                                        -35.346,
                                        0
                                    ],
                                    [
                                        0,
                                        35.346
                                    ]
                                ],
                                v: [
                                    [
                                        0,
                                        64
                                    ],
                                    [
                                        64,
                                        0
                                    ],
                                    [
                                        0,
                                        -64
                                    ],
                                    [
                                        -64,
                                        0
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "fl",
                        c: {
                            a: 0,
                            k: [
                                0.933333337307,
                                1,
                                0.980392158031,
                                1
                            ],
                            ix: 4,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 5
                        },
                        r: 1,
                        bm: 0,
                        nm: "Fill 1",
                        mn: "ADBE Vector Graphic - Fill",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var Transfer = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, Transfer as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=Transfer.json.es.js.map
